import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMapPointer12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconMapPointer12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10 4.615c0 1.284-.73 2.92-1.737 4.297-.491.672-1.012 1.23-1.473 1.61-.23.19-.428.32-.583.4a1 1 0 0 1-.195.076 1 1 0 0 1-.196-.077 3.4 3.4 0 0 1-.587-.4c-.463-.38-.987-.94-1.481-1.612C2.735 7.532 2 5.897 2 4.615 2 2.695 3.717 1 6.013 1 8.3 1 10 2.689 10 4.615m1 0C11 7.8 7.516 12 6.013 12S1 7.8 1 4.615C1 2.066 3.244 0 6.013 0S11 2.066 11 4.615m-4.143.314a.929.929 0 1 1-1.857 0 .929.929 0 0 1 1.857 0m1 0a1.929 1.929 0 1 1-3.857 0 1.929 1.929 0 0 1 3.857 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMapPointer12);
